<template>
	<div class="relative">
		<Preloader v-if="route.path === '/' && !isFinished" />
		<div
			:class="[
				'transition-opacity duration-300',
				!isFinished && route.path === '/'
					? 'opacity-0 pointer-events-none'
					: 'opacity-100',
			]"
		>
			<!-- Desktop Header -->
			<Header class="w-64 fixed left-0 top-0 h-full hidden md:block" />

			<!-- Mobile Header -->
			<div class="md:hidden">
				<NavigationMobileNav :navigation-links="navigationLinks" />
			</div>

			<main class="md:ml-64">
				<NuxtLayout>
					<NuxtPage />
				</NuxtLayout>
			</main>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useNavigation } from '~/composables/useNavigation';
import { usePreloaderState } from '~/composables/usePreloaderState';
import Preloader from '~/components/Preloader.vue';

const route = useRoute();
const { isFinished } = usePreloaderState();
const { navigationLinks } = useNavigation();

onMounted(() => {
	if (sessionStorage.getItem('preloaderPlayed')) {
		isFinished.value = true;
	}
});
</script>

<style>
.page-enter-active,
.page-leave-active {
	transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
	opacity: 0;
	filter: blur(1rem);
}
</style>
